import { useQueryClient } from "@tanstack/react-query";
import { Button } from "antd";
import { useCallback, useEffect } from "react";

type Props = {
  title: string;
  fileName: string;
  getHook: () => any;
  queryKey: any[];
};

export const ReportButton = (properties: Props) => {
  const { data, refetch, isFetching, isFetched } = properties.getHook();
  const queryClient = useQueryClient();

  const onClickHandler = useCallback(async () => {
    await refetch();
  }, [refetch]);

  useEffect(() => {
    if (isFetched) {
      const url = data?.data?.[0]?.url;
      if (url) {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", properties.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      queryClient.removeQueries({ queryKey: properties.queryKey });
    }
  }, [isFetched, data?.data?.[0]?.url, properties.fileName, properties.queryKey, queryClient.removeQueries]);

  return (
    <Button onClick={onClickHandler} loading={isFetching} className={"text-uppercase"} size={"large"}>
      {properties.title}
    </Button>
  );
};
